import useBreakpointRanges from "utilities/hooks/use-breakpoint-ranges";
import useMetaNav from "utilities/atoms/metanav-visible-atom";
import { BookviewPanelStatus } from "models/enumerations/bookview-panel-status";
import { useBookviewTabPanel } from "utilities/contexts/bookview-tab-panel/use-bookview-tab-panel";
import { useCallback } from "react";

export function useCitationClick() {
    const { collapseMetaNav } = useMetaNav();
    const { handleOpen } = useBookviewTabPanel();
    const { inMobileView } = useBreakpointRanges();

    /**
     * Handles closing the metanav and opening the bookview chat panel. Only triggers those actions
     * if clicking on a citation in the modal chat.
     */
    const handleOpenCitation = useCallback(
        (isModalChatCitation: boolean) => {
            if (inMobileView) return;
            if (isModalChatCitation) {
                collapseMetaNav();
                handleOpen(BookviewPanelStatus.BookviewChatPanel);
            }
        },
        [collapseMetaNav, handleOpen]
    );

    return {
        handleOpenCitation,
    };
}
